<template>
 <Skeleton :loading="loading">	
    <template #loading>
      <div class="box-menu px--4 py--2">
        <el-row>
          <el-col :span="20" class="pt--3">
            <SkeletonItem variant="title2" width="20%" />
          </el-col>
          <el-col :span="4" class="pt--3">
            <SkeletonItem variant="heading3" />
          </el-col>
        </el-row>
        <SkeletonItem variant="body" width="25%" />
        <el-row v-for="(num) in 2" :key="num" class="pa--2">
          <el-col :span="3">
            <div class="shape-circle" style="width: 20px; height: 20px; border: 0.5px solid #BCBCBC;"/>
          </el-col>
          <el-col :span="21">
            <SkeletonItem variant="heading3" width="30%" />
            <el-divider class="color-whitesmoke mt--2 mb--0" />
          </el-col>
        </el-row>
      </div>
    </template>
    <template>
      <slot />
    </template>
 </Skeleton>
</template>

<script>
  export default {
    name: 'MenuOptionLoader',
    props: {
      loading: { default: false }
    }
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/menudetail/MenuOptionLoader.vue